var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51404_1948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 0C179.063 0 0 179.063 0 400C0 620.938 179.063 800 400 800C620.938 800 800 620.938 800 400C800 179.063 620.938 0 400 0ZM488.281 332.188L483.75 392.031H422.344V599.844H344.844V392.031H303.438V332.188H344.844V292.031C344.844 274.375 345.312 247.031 358.125 230C371.719 212.031 390.312 199.844 422.344 199.844C474.531 199.844 496.406 207.344 496.406 207.344L486.094 268.594C486.094 268.594 468.906 263.594 452.812 263.594C436.719 263.594 422.344 269.375 422.344 285.469V332.188H488.281Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51404_1948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSocial);
export default __webpack_public_path__ + "static/media/facebook-social.0f7eec14e95b64b56c4795b8aecdb5c7.svg";
export { ForwardRef as ReactComponent };